export const PROGRAM_ARMS = {
  communityService: 'community-service',
  quranEducation: 'quran-education',
};

export const PROGRAM_CATEGORIES = ['Community Service', "Qur'an Education & Gatherings"];

export const PROGRAMS = [
  {
    slug: 'standard-service',
    title: 'Standard Service',
    arm: PROGRAM_ARMS.communityService,
    category: 'Community Service',
    isFlagship: false,
    summary:
      'Our baseline community service engine operating on the second weekend of the month during our 10-month active season.',
    schedule: 'Second weekend monthly — 10-month active season',
    description:
      'The steady heartbeat of our community service efforts, running consistently on the second weekend of the month during our 10-month active season. Recognizing that serving the creation is a means of drawing closer to the Creator, these activations are a form of active sadaqah. Our supportive volunteer family engages in impactful activities such as masjid and graveyard cleanups, homeless feedings, and volunteering at local shelter homes.',
  },
  {
    slug: 'warmth-and-wisdom',
    title: 'Warmth & Wisdom',
    arm: PROGRAM_ARMS.communityService,
    category: 'Community Service',
    isFlagship: true,
    summary: 'December humanitarian outreach at Woodruff Park.',
    schedule: 'December',
    description:
      "Our winter flagship event that takes center stage during our 10-month active service calendar. Bringing different communities together to support our local homeless population, volunteers follow the Prophetic sunnah of mercy to provide essential care—including warm food, winter clothes, hygiene kits, free barbering services, and copies of the Qur'an. It is a beautiful manifestation of faith in action.",
  },
  {
    slug: 'iftaar-preparation',
    title: 'Iftaar Preparation',
    arm: PROGRAM_ARMS.communityService,
    category: 'Community Service',
    isFlagship: true,
    summary: 'Ramadan food preparation and packing logistics.',
    schedule: 'Ramadan season',
    description:
      "Our Ramadan flagship operation, serving as a seasonal pillar of our 10-month active calendar. Designed to earn the immense reward of feeding a fasting person, this initiative brings people together to manage the operational logistics of food preparation, fruit packing, and catering pipelines. Serving fasting individuals across a wide range of partner masajid, it is a display of the Ummah's unity and generosity.",
  },
  {
    slug: 'weekly-quran-circles',
    title: "Weekly Qur'an Circles",
    arm: PROGRAM_ARMS.quranEducation,
    category: "Qur'an Education & Gatherings",
    isFlagship: false,
    summary:
      'Consistent, weekly gatherings for continuous recitation, memorization, and reflection in a supportive space.',
    schedule: 'Weekly',
    description:
      "Consistent, weekly gatherings dedicated to continuous recitation, memorization, and reflection. Building a relationship with the Qur'an requires steady, supportive companionship. These circles provide a welcoming, judgment-free space for individuals to gather regularly, correct their recitation, and anchor their week in the remembrance of Allah.",
  },
  {
    slug: 'summer-intensive',
    title: 'Summer Intensive',
    arm: PROGRAM_ARMS.quranEducation,
    category: "Qur'an Education & Gatherings",
    isFlagship: false,
    summary: '10-week virtual Tajweed, Arabic, and Seerah program.',
    schedule: 'June — summer season',
    description:
      'A comprehensive 10-week summer educational program designed for individuals to deeply benefit from foundational Islamic sciences. Because seeking knowledge is a sacred path to Jannah, this intensive provides a highly supportive, accessible environment to study Tajweed, Arabic, Seerah, and more. It is an invitation to ground oneself in the tradition.',
  },
  {
    slug: 'quran-nights',
    title: 'Quran Nights',
    arm: PROGRAM_ARMS.quranEducation,
    category: "Qur'an Education & Gatherings",
    isFlagship: false,
    summary: 'Recurring spiritual gatherings for recitation and reflection.',
    schedule: 'August, October, January, and May',
    description:
      "A night of recitations and inspiring stories designed to help individuals draw closer to the Qur'an. In Islam, gathering to remember Allah brings tranquility and the presence of angels. We host these deeply supportive nights across various spaces—including local masajid, academic institutions, and universities—welcoming all who seek a connection to Revelation.",
  },
  {
    slug: 'quran-competition',
    title: 'Collegiate Quran Competition',
    arm: PROGRAM_ARMS.quranEducation,
    category: "Qur'an Education & Gatherings",
    isFlagship: true,
    summary: 'Annual collegiate recitation competition with formal testing brackets.',
    schedule: 'April — annual',
    description:
      "Our flagship annual event featuring formal testing categories and public recitation performances. Designed for youth and young adults (ages 16–25), this competition is a beautiful opportunity to push oneself in the pursuit of preserving Allah's Book. Built on a highly encouraging culture that celebrates every effort, registration opens in October with the main gathering taking place every April.",
  },
];

export const COMMUNITY_SERVICE_PROGRAMS = PROGRAMS.filter(
  (p) => p.arm === PROGRAM_ARMS.communityService
);

export const QURAN_EDUCATION_PROGRAMS = PROGRAMS.filter(
  (p) => p.arm === PROGRAM_ARMS.quranEducation
);

export const PROGRAM_CATEGORY_OPTIONS = [
  {
    arm: PROGRAM_ARMS.communityService,
    title: 'Community Service',
    subtitle: 'Our 10-month active service engine and seasonal flagship initiatives',
    programs: COMMUNITY_SERVICE_PROGRAMS,
  },
  {
    arm: PROGRAM_ARMS.quranEducation,
    title: "Qur'an Education & Gatherings",
    subtitle: 'Weekly circles, summer intensives, and annual competitions',
    programs: QURAN_EDUCATION_PROGRAMS,
  },
];

export function getProgramBySlug(slug) {
  return PROGRAMS.find((p) => p.slug === slug);
}

export const HOME_FEATURED_PROGRAMS = [
  'standard-service',
  'quran-nights',
  'weekly-quran-circles',
]
  .map(getProgramBySlug)
  .filter(Boolean);
